import React, { createContext, useContext, useState } from 'react'

const PaginationContext = createContext()

export const usePagination = () => useContext(PaginationContext)

export const PaginationProvider = ({ children }) => {
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })

  return (
    <PaginationContext.Provider value={{ pagination, setPagination }}>
      {children}
    </PaginationContext.Provider>
  )
}
